// extracted by mini-css-extract-plugin
module.exports = {"button":"TrendingFilterButton_button__Fvj-f"};